module.exports = __webpack_public_path__ + "media/images/common/still-fe7bb44710588105d2170ccb70724d87.gif";